// components/Attendance.js
import React from 'react';

const StaffAttendance = () => {
  const attendanceData = [
    { date: '28 Dec 2024', status: 'Present' },
    { date: '27 Dec 2024', status: 'Present' },
    { date: '26 Dec 2024', status: 'Absent' },
    { date: '25 Dec 2024', status: 'Present' },
    { date: '24 Dec 2024', status: 'Present' },
  ];

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Attendance</h1>
      
      {/* Date Range */}
      <div className="flex justify-between mb-6">
        <div className="flex-1 mr-2">
          <label className="block text-gray-500 text-sm mb-1">Start Date</label>
          <div className="border rounded p-2">00-00-0000</div>
        </div>
        <div className="flex-1 ml-2">
          <label className="block text-gray-500 text-sm mb-1">End Date</label>
          <div className="border rounded p-2">00-00-0000</div>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="bg-blue-50 rounded-lg p-4 text-center">
          <p className="text-2xl font-bold">00</p>
          <p className="text-gray-600">Present</p>
        </div>
        <div className="bg-blue-50 rounded-lg p-4 text-center">
          <p className="text-2xl font-bold">00</p>
          <p className="text-gray-600">Absent</p>
        </div>
        <div className="bg-blue-50 rounded-lg p-4 text-center">
          <p className="text-2xl font-bold">00</p>
          <p className="text-gray-600">Undertime</p>
        </div>
        <div className="bg-blue-50 rounded-lg p-4 text-center">
          <p className="text-2xl font-bold">00</p>
          <p className="text-gray-600">Overtime</p>
        </div>
      </div>

      {/* Attendance List */}
      <div className="space-y-3">
        {attendanceData.map((item, index) => (
          <div key={index} className="border rounded-lg p-3 flex justify-between items-center">
            <span className="font-medium">{item.date}</span>
            <span className={`px-3 py-1 rounded-full text-sm ${item.status === 'Present' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
              {item.status}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StaffAttendance;